export default {
  methods: {
    setOverrideProps(data, override) {
      if (!this.isObj(data)) {
        return data;
      }

      return Object.keys(data)
        .reduce(
          (obj, key) => {
            const proxy = obj;

            const setPropValue = (value) => {
              proxy[key] = value;
            };

            if (this.isEmptyItem(override)) {
              setPropValue(data || override);
              return proxy;
            }

            let item = data[key];
            const overrideItem = override[key];

            if (this.isObj(item)) {
              if (Array.isArray(item)) {
                item = item.map(
                  (i) => this.setOverrideProps(i, overrideItem),
                );
              } else {
                item = this.setOverrideProps(item, overrideItem);
              }
            }

            setPropValue(this.isEmptyItem(item) ? overrideItem : item);

            return proxy;
          },
          {},
        );
    },
    isObj(item) {
      return typeof item === 'object' && item !== null;
    },
    isEmptyItem(item) {
      return item === null || item === undefined || item === '';
    },
  },
};
